export const isValidEmail = (email: string) => {
  if (email === null || email === undefined || email === "") return true;

  if (email === " ") return false;

  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailPattern.test(email);
};
